/**
 * @func capitalize
 * @param {string} text - The string value to format.
 * @return {string}
 * @desc Capitalizes the first character of a string
 * ```js
 * capitalize('some text');
 * // returns "Some text"
 * ```
 * @memberof module:String
 * @instance
 */
function capitalize(text) {
    if (typeof text !== 'string')
        return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export { capitalize as default };
